import { html, TemplateResult } from 'lit';
import { translateFn } from '../utils/translator.helper';
import { FontSizes, FontWeights } from '../types/common/types';

export function renderSideMenuDescription(description: string): TemplateResult {
  return html`
    <gz-labeled-content label="${translateFn('Description')}"></gz-labeled-content>
    <gz-text fontSize="${FontSizes.PARAGRAPH_12}"> ${description} </gz-text>
  `;
}

export enum AnswerType {
  YES = 1,
  NO = 2,
}

export function renderSideMenuSectionTitle(title: string) {
  return html`
    <gz-title
      fontSize="${FontSizes.PARAGRAPH_11}"
      fontWeight="${FontWeights.MEDIUM}"
      class="section-title text-uppercase mb-2"
      >${title}
    </gz-title>
  `;
}

export const INVALID_SHOW_MORE = -1;
